import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { environment } from "src/environments/environment";
import { Router} from "@angular/router";

declare var gtag;
declare var fbq;
@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.css']
})
export class AboutusComponent implements OnInit {

  constructor(private service:AppService, private router: Router) { }

  data:any='';
  loader:boolean=false;
  ngOnInit() {
    if(environment.production){
    this.service.sendEvents("CompleteaboutUs", "aboutUs", "AboutUs");
    fbq('track', "CompleteAboutUs" , {
      content_type: "aboutUs",
      content_title: this.router.url,
    });
    }
    

    this.service.setTitle('About Us | Propira');
    this.service.setMetaTags({ property: "og:title", content: 'About Us | Propira' });
    this.service.setMetaTags({ name: "keywords", content: 'Best Property Portal in Alwar, Best Property Site in India, Local Listing Site, Rental Properties in Alwar, Commercial Properties in Alwar, Buy/sell Industrial Space in Alwar, Ready to move Lands' });
    this.service.setMetaTags({ name: "description", content: 'Propira is an independent real estate advisor, on this portal you can buy, sell & list your property and we aim at creating a genuine buyer-seller relationship.' });
    this.service.setMetaTags({ property: "og:description", content: 'Propira is an independent real estate advisor, on this portal you can buy, sell & list your property and we aim at creating a genuine buyer-seller relationship.' });

    this.loader=true;
    this.service.get('/aboutUsInfo').subscribe(
      data=>{
        if(data[0].error=='0'){
          this.data=data[0].description;
        }
        this.loader=false;
      },error=>{
        this.loader=false;
        console.log('in error');
      }
    )

    this.getPropertySnapshot();
  } 

  propertysnapshot:any;
  getPropertySnapshot(){
    this.service.get('/propertySnapshotData').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.propertysnapshot=data[0];
        }
      },error=>{
        console.log('in error');
      }
    )
  }

}
